import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { GET, APIImpl } from '../api';
import { SettingsRequest } from './settingsrequest';

export class SettingsAPI extends APIImpl<SettingsRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/security-token
        return "settings";
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/settings/settingsapi.tsx